import { DatePipe } from '@angular/common';

const datePipe = new DatePipe('pt-BR');

export function formatDateToAAAAMMDD(date: Date): string {
  const formattedDate = datePipe.transform(date, 'yyyyMMdd');
  return formattedDate ? formattedDate : '';
}
